/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
export class AuthorityClearanceApi extends BaseApi {
    getAuthorityClearanceForAuthority(authorityId, opts) {
        const pathParams = {
            authorityId
        };
        return this.get({
            path: '/cleared-authorities/{authorityId}/clearing-marks',
            pathParams,
            queryParams: opts
        });
    }
    updateAuthorityClearance(authorityId, authorityClearance) {
        const pathParams = {
            authorityId
        };
        return this.post({
            path: '/cleared-authorities/{authorityId}/clearing-marks',
            pathParams,
            bodyParam: authorityClearance
        });
    }
}
